export default __webpack_public_path__ + "static/O0080-fefdc2871bda3b53281b8023c08f5ca8.png";